import { createContext, useState } from "react";

export const AdressNavigation = createContext()

export const AdressNavigationProvider = (props) => {
    const [adressNavigation, setAdressNavigation] = useState("dashboard")

    return(
        <AdressNavigation.Provider value={[adressNavigation, setAdressNavigation]}>
            {props.children}
        </AdressNavigation.Provider>
    )
}